import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/StoreContext";
import SiteLayout from "@/components/layout/SiteLayout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Favorites from "@/pages/Favorites";
import InfoPage from "@/pages/InfoPage";
import AboutPage from "@/pages/AboutPage";
import ContactsPage from "@/pages/ContactsPage";
import AccountPage, { ForgotPassword, ResetPassword } from "@/pages/AccountPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderPage from "@/pages/OrderPage";
import { CustomerProvider } from "@/context/CustomerContext";
import { AdminOrders, AdminOrderDetail } from "@/admin/AdminOrders";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminProductList from "@/admin/AdminProductList";
import AdminNewProduct from "@/admin/AdminNewProduct";
import AdminProductEditor from "@/admin/AdminProductEditor";
import AdminCategoryManager from "@/admin/AdminCategoryManager";
import AdminInventory from "@/admin/AdminInventory";
import AdminSettings from "@/admin/AdminSettings";
import AdminUsers from "@/admin/AdminUsers";
import AdminAudit from "@/admin/AdminAudit";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import { INFO_PAGES, LEGAL_SLUGS } from "@/lib/infoPages";
import LegalPage from "@/pages/LegalPage";
import AdminLegal from "@/admin/AdminLegal";
import AdminPrelaunch from "@/admin/AdminPrelaunch";

function App() {
  return (
    <SettingsProvider>
    <StoreProvider>
      <BrowserRouter>
      <CustomerProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/collezione" element={<Catalog />} />
            <Route path="/categoria/:slug" element={<Catalog />} />
            <Route path="/prodotto/:slug" element={<ProductDetail />} />
            <Route path="/preferiti" element={<Favorites />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/account/recupera-password" element={<ForgotPassword />} />
            <Route path="/account/reimposta-password" element={<ResetPassword />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/ordine/:number" element={<OrderPage />} />
            <Route path="/chi-siamo" element={<AboutPage />} />
            <Route path="/contatti" element={<ContactsPage />} />
            {LEGAL_SLUGS.map((s) => <Route key={s} path={`/${s}`} element={<LegalPage slug={s} />} />)}
            {Object.keys(INFO_PAGES).map((p) => (
              <Route key={p} path={`/${p}`} element={<InfoPage page={p} />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
          <Route path="/admin" element={<AuthProvider><AdminLayout /></AuthProvider>}>
            <Route index element={<AdminDashboard />} />
            <Route path="prodotti" element={<AdminProductList />} />
            <Route path="prodotti/nuovo" element={<AdminNewProduct />} />
            <Route path="prodotti/:id" element={<AdminProductEditor />} />
            <Route path="categorie" element={<AdminCategoryManager />} />
            <Route path="magazzino" element={<AdminInventory />} />
            <Route path="ordini" element={<AdminOrders />} />
            <Route path="ordini/:id" element={<AdminOrderDetail />} />
            <Route path="impostazioni" element={<AdminSettings />} />
            <Route path="utenti" element={<AdminUsers />} />
            <Route path="registro" element={<AdminAudit />} />
            <Route path="pagine-legali" element={<AdminLegal />} />
            <Route path="pre-lancio" element={<AdminPrelaunch />} />
          </Route>
        </Routes>
      <Toaster position="top-center" duration={2500} visibleToasts={2} offset={90} mobileOffset={{ top: 80 }} />
      </CustomerProvider>
      </BrowserRouter>
    </StoreProvider>
    </SettingsProvider>
  );
}

export default App;
